__turbopack_context__.v({
  "arrow-flex": "_7OP4pG_arrow-flex",
  "center-wrap": "_7OP4pG_center-wrap",
  "contents-container": "_7OP4pG_contents-container",
  "header-container": "_7OP4pG_header-container",
  "header-wrap": "_7OP4pG_header-wrap",
  "left-wrap": "_7OP4pG_left-wrap",
  "reverse-arrow-link": "_7OP4pG_reverse-arrow-link",
  "right-wrap": "_7OP4pG_right-wrap",
  "simple-flex": "_7OP4pG_simple-flex",
});
